<div class="map-container">
  <div [id]="mapElementId" class="locations-map"></div>
  
  <!-- Mobile: Simplified bottom modal (Airbnb style) -->
  <div class="mobile-location-modal" *ngIf="isMobile && selectedLocation" (click)="onModalClick()">
    <div class="mobile-modal-content">
      <div class="mobile-modal-image">
        <button class="mobile-modal-close" (click)="closeMobileModal(); $event.stopPropagation()" aria-label="Close">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M18 6L6 18M6 6l12 12"/>
          </svg>
        </button>
        <img 
          [src]="getFirstImage(selectedLocation)" 
          [alt]="selectedLocation.Name"
          (error)="onImageError($event)"
          #locationImage
        />
        <svg class="mobile-modal-fallback" #fallbackImage viewBox="0 0 400 300" style="display: none;" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
          <rect width="400" height="300" fill="#e9ecef"></rect>
          <rect x="50" y="50" width="300" height="200" fill="#d0d0d0" rx="4"></rect>
          <text x="50%" y="50%" text-anchor="middle" fill="#999" font-size="14" dy=".3em">{{ selectedLocation.Name }}</text>
        </svg>
      </div>
      
      <div class="mobile-modal-info">
        <p class="mobile-modal-location">
          {{ selectedLocation.City }}, {{ getStateAbbreviation(selectedLocation.State) }}<span *ngIf="getDistanceDisplay(selectedLocation)"> ({{ getDistanceDisplay(selectedLocation) }})</span>
        </p>
        <h3 class="mobile-modal-title">{{ selectedLocation.Name }}</h3>
        <div class="mobile-modal-rating" *ngIf="selectedLocation.AverageRating">
          <span class="mobile-modal-star">★</span>
          <span class="mobile-modal-rating-value">{{ selectedLocation.AverageRating }}</span>
          <span class="mobile-modal-rating-count">({{ selectedLocation.ReviewCount || 0 }} reviews)</span>
        </div>
      </div>
    </div>
  </div>
</div>
